<template></template>

<script setup lang="ts">
import { type GoogleRecaptchaSettings } from '@/modules/core/types';
import { useOccCommonDataStore } from '../store';


interface Props {
    googleRecaptchaSettings?: GoogleRecaptchaSettings;
}

const props = defineProps<Props>();

useOccCommonDataStore().$patch(props)
</script>
